/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import './styles.scss';
import {
  FaCheck, FaEraser,
} from 'react-icons/fa';
import PropTypes from 'prop-types';
import EpButton from '../EpButton';
import EpModalStick from '../EpModalStick';
import EpLocalLoading from '../EpLocalLoading';
import useTranslation from '../../hooks/useTranslation';
// import useForm from '../../hooks/useForm';

const EpModalStickFilters = ({
  bodyContent, modalStickId, buttonToggleId, submitFunc, clearFunc, searchingData, cancelFunc,
}) => {
  // Tags do Globalization
  const Cancel = useTranslation('Cancel');
  const Clear = useTranslation('Clear');
  const Run = useTranslation('Run');
  const Filters = useTranslation('Filters');

  const buttonIcon = (
    searchingData
      ? (<EpLocalLoading customClass="modal-stick-filter__button-loading" />)
      : (
        <FaCheck className="btn__icon" />
      )
  );

  const headerContent = (
    <>
      <EpButton
        linkFunc={clearFunc}
        actionType="button"
        labelText=""
        buttonType="secondary-outline"
        customClass="btn__footer--clear"
        buttonIcon={<FaEraser />}
        disabled={false}

      />
      <EpButton
        linkFunc={submitFunc}
        actionType="submit"
        labelText=""
        buttonType="primary"
        customClass="btn__header--run"
        buttonIcon={buttonIcon}
        disabled={searchingData}
      />
    </>

  );

  const footerContent = (
    <>
      <EpButton
        actionType="button"
        labelText={Cancel}
        data-bs-dismiss="modal"
        buttonType="secondary-outline"
        customClass="btn__footer--close"
        linkFunc={cancelFunc}
        disabled={false}
      />
      <div className="modal-stick__content-footer-buttons">
        <EpButton
          linkFunc={clearFunc}
          actionType="button"
          labelText={Clear}
          buttonType="secondary-outline"
          customClass="btn__footer--clear"
          buttonIcon={<FaEraser className="btn__icon" />}
          disabled={false}
        />
        <EpButton
          linkFunc={submitFunc}
          actionType="submit"
          labelText={Run}
          buttonType="primary"
          customClass="btn__footer--run"
          buttonIcon={buttonIcon}
          disabled={searchingData}
        />
      </div>
    </>
  );

  return (
    <EpModalStick
      modalStickId={modalStickId}
      buttonToggleId={buttonToggleId}
      headerTitle={Filters}
      headerContent={headerContent}
      bodyContent={bodyContent}
      footerContent={footerContent}
    />
  );
};

export default EpModalStickFilters;

EpModalStickFilters.defaultProps = {
  submitFunc: null,
  clearFunc: null,
  searchingData: false,
  cancelFunc: null,
};

EpModalStickFilters.propTypes = {
  bodyContent: PropTypes.element.isRequired,
  modalStickId: PropTypes.string.isRequired,
  buttonToggleId: PropTypes.string.isRequired,
  submitFunc: PropTypes.func,
  clearFunc: PropTypes.func,
  searchingData: PropTypes.bool,
  cancelFunc: PropTypes.func,
};
